module.exports = __webpack_public_path__ + "img/namecardai-logo.20154145.png";